// ** Reducers Imports
import auth from './authentication'
import cars from '@src/views/cars/store'
import acts from '@src/views/repair/act/store'
import haul from '@src/views/haul/store'
import rents from '@src/views/rents/store'
import files from '@src/views/files/store'
import leads from '@src/views/customers/leads/store'
import navbar from './navbar'
import layout from './layout'
import credits from '@src/views/credits/store'
import clients from '@src/views/repair/clients/store'
import stations from '@src/views/repair/stations/store'
import finances from '@src/views/finances/store'
import calendar from '@src/views/calendar/store'
import dashboard from '@src/views/dashboard/store'
import inventory from '@src/views/warehouse/inventory/store'
import accounts from '@src/views/accounts/store'
import company from '@src/views/company/store'
import deposits from '@src/views/deposits/store'
import currency from '@src/@core/layouts/components/navbar/store'
import products from '@src/views/warehouse/products/store'
import services from '@src/views/repair/services/store'
import contacts from '@src/views/repair/contacts/store'
import documents from '@src/views/documents/store'
import suppliers from '@src/views/warehouse/suppliers/store'
import customers from '@src/views/customers/store'
import blacklist from '@src/views/black-list/store'
import personChecksList from '@src/views/company/personChecks/store'
import insurance from '@src/views/insurance/store'
import investors from '@src/views/investors/store'
import accidents from '@src/views/accidents/store'
import warehouses from '@src/views/warehouse/warehouses/store'
import promissory from '@src/views/promissory/store'
import service_cars from '@src/views/repair/cars/store'
import service_employees from '@src/views/repair/employees/store'
import notifications from '@src/@core/layouts/components/navbar/store/notifications'
import requests from '@src/views/requests/store'
import requestSources from '@src/views/requests/sources/store'

const rootReducer = {
  auth,
  acts,
  cars,
  haul,
  rents,
  files,
  leads,
  navbar,
  layout,
  company,
  credits,
  clients,
  stations,
  finances,
  calendar,
  accounts,
  deposits,
  currency,
  products,
  services,
  contacts,
  documents,
  suppliers,
  dashboard,
  inventory,
  customers,
  blacklist,
  personChecksList,
  insurance,
  investors,
  accidents,
  warehouses,
  promissory,
  service_cars,
  service_employees,
  notifications,
  requests,
  requestSources
}

export default rootReducer
